import { render, staticRenderFns } from "./aprovacaoDoacoes.vue?vue&type=template&id=210bbc28&scoped=true&"
import script from "./aprovacaoDoacoes.vue?vue&type=script&lang=js&"
export * from "./aprovacaoDoacoes.vue?vue&type=script&lang=js&"
import style0 from "./aprovacaoDoacoes.vue?vue&type=style&index=0&id=210bbc28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210bbc28",
  null
  
)

export default component.exports